'use client'
import { memo } from 'react'
import styled from 'styled-components'
import { mq, vw, getP10 } from '@/styles'
import { Figure } from '../Figure'

const parserMedia = (data) => {
  if (data?.type === 'svg') {
    return ({
      type: data.type,
      alt: data.alt,
      default: {
        src: data.url
      }
    })
  }

  if (!data?.default) return data
  const media = {
    type: data.type,
    alt: data.alt,
    default: {
      src: data?.default?.['2x']?.regular ?? data?.default?.['2x']?.compressed,
      size: {
        height: data?.default?.size?.height,
        width: data?.default?.size?.width,
      }
    }
  }

  return media
}

type ContentTypeImage = {
  col: { from: number, expand: number},
  row: { from: number, expand: number},
  media: any,
  alt: string,
  caption?: string,
  type: 'image' | 'media',
  media_caption?: string
  media_size?: 'small' | 'medium' | 'big'
}

interface IContentImage {
  data: ContentTypeImage
}

export const ContentImage = memo(({ data }:IContentImage) => {
  const { media } = data

  return (
    <FigureStyled media={media?.default.src ? media : parserMedia(media)} />
  )
})


const FigureStyled = styled(Figure) <any>`
  height: auto;
  width: 100%;

  > span {
    position: relative !important;
    height: auto;
    width: 100%;
  }

  img {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
  }

  figcaption {
    color: inherit;
    font-family: var(--font-platform);
    font-style: normal;
    ${getP10()}
    opacity: .5;
    text-align: center;
    text-transform: uppercase;
    margin-top: ${vw(10, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-top: ${vw(10, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-top: ${vw(10, 'desktop')};
    }

    ${mq.greaterThan('tablet')} {
      margin-top: 10px;
    }
  }
`
